export default style => typeof style === 'object' ? style : {}; // eslint-disable-line
